import type { ReactNode } from 'react';

export const symbol_payment_card: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm110-80h275q17 0 25.5-14.5t.5-29.5L389-644q-3.61-8-10.83-12-7.23-4-15.17-4H250q-12.75 0-21.37 8.62Q220-642.75 220-630v300q0 12.75 8.63 21.37Q237.25-300 250-300Zm343-255h95q22.1 0 37.05-15.5Q740-586 740-608.07t-15.5-37Q709-660 687-660h-95q-22.1 0-37.05 14.93-14.95 14.93-14.95 37t15.5 37.57Q571-555 593-555ZM140-220v-520 520Z"
		/>
	</svg>
);
